import en from './messages/en.json';
import de from './messages/de.json';

export const locales = ['en', 'de'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'de';

export const messages = {
    en,
    de,
} as const;

export type Messages = typeof en;

// Cookie configuration for sharing across subdomains
export const COOKIE_NAME = 'hfu-language';
export const COOKIE_DOMAIN = '.hfu.digital';
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year in seconds

export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return decodeURIComponent(parts.pop()?.split(';').shift() || '');
    }
    return null;
}

export function setCookie(name: string, value: string): void {
    if (typeof document === 'undefined') return;

    const isLocalhost =
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    const domainPart = isLocalhost ? '' : `domain=${COOKIE_DOMAIN};`;
    const securePart = isLocalhost ? '' : 'Secure;';
    document.cookie = `${name}=${encodeURIComponent(value)};${domainPart}path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax;${securePart}`;
}

export function getLocaleFromCookie(): Locale {
    const stored = getCookie(COOKIE_NAME);
    if (stored && locales.includes(stored as Locale)) {
        return stored as Locale;
    }
    return defaultLocale;
}
